import globalLibraries from './globalLibraries'
import globalComponents from './globalComponents'
import globalFilters from './globalFilters'

const Plugins = {
  install(Vue) {
    Vue.use(globalLibraries)
    Vue.use(globalComponents)
    Vue.use(globalFilters)
  },
}

export default Plugins
